var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeterinariasIlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 377,
    viewBox: "0 0 523 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5151_105939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.098 149.548L139.491 187.037V237.024L205.098 199.534V149.548Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 187.037L73.8845 149.548V199.534L139.491 237.024V187.037Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 187.039L128.166 199.536V212.032L139.491 205.784V187.039Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.168 199.536L62.5617 162.047V174.543L128.168 212.033V199.536Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 187.037L73.8844 149.548L62.5595 162.044L128.166 199.534L139.491 187.037Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 99.5645L95.8025 124.558L139.15 150.332L183.229 124.558L139.491 99.5645Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.098 149.55L183.229 124.557L139.491 149.55V187.43L205.098 149.55Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 187.43V149.55L95.7534 124.557L73.8845 149.55L139.491 187.43Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.147 172.588L71.5405 132.755V151.5L137.147 191.333V172.588Z",
    fill: "#E1DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 171.419L137.148 172.59V191.335L139.491 190.164V171.419Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8844 131.586L71.5413 132.757L137.148 172.981L139.491 171.809L73.8844 131.586Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.562 176.105L184.361 180.792V193.288L192.562 188.602V176.105Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39 176.785L184.361 180.791V191.726L191.39 187.821V176.785Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.018 191.534L156.817 196.22V208.717L165.018 204.031V191.534Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.845 192.216L156.816 196.222V207.156L163.845 203.251V192.216Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.107 149.548L410.714 187.037V237.024L345.107 199.534V149.548Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.714 187.037L476.321 149.548V199.534L410.714 237.024V187.037Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.714 187.039L422.039 199.536V212.032L410.714 205.784V187.039Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.037 199.536L487.644 162.047V174.543L422.037 212.033V199.536Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.714 187.037L476.321 149.548L487.646 162.044L422.039 199.534L410.714 187.037Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.712 99.5645L454.4 124.558L411.053 150.332L366.974 124.558L410.712 99.5645Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.107 149.55L366.976 124.557L410.714 149.55V187.43L345.107 149.55Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.714 187.43V149.55L454.452 124.557L476.321 149.55L410.714 187.43Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.058 172.588L478.665 132.755V151.5L413.058 191.333V172.588Z",
    fill: "#E1DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.714 171.419L413.057 172.59V191.335L410.714 190.164V171.419Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.321 131.586L478.664 132.757L413.057 172.981L410.714 171.809L476.321 131.586Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.64 176.105L365.841 180.792V193.288L357.64 188.602V176.105Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.812 176.785L365.841 180.791V191.726L358.812 187.821V176.785Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.186 191.534L393.387 196.22V208.717L385.186 204.031V191.534Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.359 192.216L393.389 196.222V207.156L386.359 203.251V192.216Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.624 189.663L275.148 239.649V314.628L362.624 264.642V189.663Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.149 239.649L187.673 189.663V264.642L275.149 314.628V239.649Z",
    fill: "#FFD87A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.148 140.455L187.672 189.66L275.148 239.646L362.624 189.66L275.148 140.455Z",
    fill: "#72D2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.149 278.7L362.624 228.714V231.057L275.149 281.043V278.7Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.672 228.714L275.148 278.681V281.024L187.672 231.057V228.714Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.148 131.865L209.931 169.355L275.148 206.063L340.754 169.355L275.148 131.865Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.148 239.647V206.063L340.755 169.354L362.624 189.661L275.148 239.647Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.673 189.661L209.932 169.354L275.149 206.063V239.647L187.673 189.661Z",
    fill: "#FEC847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.429 170.137L261.867 170.918V195.911L263.429 195.13V170.137Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.875 155.297L235.313 156.078V181.071L236.875 180.29V155.297Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.869 170.918L260.307 170.137V195.13L261.869 195.911V170.918Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.316 156.078L233.754 155.297V180.29L235.316 181.071V156.078Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7 203.72L183.765 209.577V252.144L194.7 245.896V203.72Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.768 209.579L176.739 205.674V247.85L183.768 252.145V209.579Z",
    fill: "#FFD87A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7 203.723L187.671 199.817L176.736 205.675L183.765 209.971L194.7 203.723Z",
    fill: "#FFF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.677 165.448L226.33 140.455V165.448L269.677 190.441V165.448Z",
    fill: "#FFD87A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.149 162.324L269.681 165.448V190.441L275.149 187.317V162.324Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.801 137.333L226.334 140.457L269.681 165.45L275.149 162.326L231.801 137.333Z",
    fill: "#FFF5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.55 139.678L280.616 145.926V158.423L291.55 152.174V139.678Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.681 127.178L258.747 133.426L280.616 145.923L291.55 139.674L269.681 127.178Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.613 145.924L258.744 133.428L259.134 145.924L280.613 158.421V145.924Z",
    fill: "#FFD87A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.055 212.31L344.855 216.996V229.492L353.055 224.806V212.31Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.884 212.991L344.855 216.997V227.932L351.884 224.027V212.991Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.835 247.408L345.634 252.094V264.591L353.835 259.905V247.408Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.666 248.088L345.636 252.094V263.028L352.666 259.123V248.088Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.282 225.464L319.081 230.15V242.647L327.282 237.96V225.464Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.109 226.146L319.08 230.152V241.086L326.109 237.181V226.146Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.063 260.557L319.863 265.243V277.739L328.063 273.053V260.557Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.891 261.238L319.861 265.244V276.179L326.891 272.274V261.238Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.945 241.083L291.744 245.769V258.266L299.945 253.58V241.083Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.774 241.765L291.745 245.771V256.705L298.774 252.8V241.765Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.726 276.18L292.525 280.866V293.362L300.726 288.676V276.18Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.555 276.861L292.525 280.867V291.802L299.555 287.897V276.861Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.649 248.059L254.839 243.764V256.26L262.649 260.556V248.059Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.649 248.059L256.011 244.41V255.479L262.649 258.994V248.059Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.306 282.495L252.496 278.199V290.696L260.306 294.991V282.495Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.306 282.494L253.667 278.845V289.913L260.306 293.428V282.494Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.34 231.642L226.53 227.347V239.843L234.34 244.139V231.642Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.34 231.641L227.701 227.992V239.061L234.34 242.576V231.641Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.605 265.853L223.795 261.558V274.054L231.605 278.35V265.853Z",
    fill: "#6A339D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.607 265.852L224.968 262.203V273.272L231.607 276.786V265.852Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.069 217.19L200.258 212.895V225.391L208.069 229.687V217.19Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.069 217.189L201.43 213.54V224.609L208.069 228.123V217.189Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.674 251.406L198.864 247.11V259.607L206.674 263.903V251.406Z",
    fill: "#AE8301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.674 251.405L200.036 247.756V258.825L206.674 262.339V251.405Z",
    fill: "#E2AA01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.789 252.309L438.36 221.207L329.503 283.411L383.931 314.514L492.789 252.309Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.789 252.31L483.718 247.126L374.86 309.33L383.931 314.514L492.789 252.31Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.432 226.391L438.36 221.207L329.502 283.411L338.574 288.595L447.432 226.391Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.136 248.422L444.192 247.126L426.049 257.493L427.993 258.789L446.136 248.422Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.299 278.228L392.355 276.932L374.212 287.299L376.156 288.595L394.299 278.228Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.645 283.411L166.216 314.514L57.358 252.309L111.787 221.207L220.645 283.411Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.645 283.411L211.573 288.595L102.715 226.39L111.787 221.207L220.645 283.411Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.287 309.33L166.216 314.514L57.3579 252.309L66.4294 247.126L175.287 309.33Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.991 287.299L172.047 288.595L153.904 278.227L155.848 276.931L173.991 287.299Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.154 257.493L120.21 258.789L102.067 248.422L104.011 247.126L122.154 257.493Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4304 247.124L102.716 226.389L53.9888 198.535C48.2286 195.242 41.1566 195.241 35.3951 198.531L19.3431 207.698C14.4993 210.464 14.4984 217.448 19.3413 220.215L66.4304 247.124Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1338 225.094L63.1899 226.39L45.047 216.022L46.9908 214.726L65.1338 225.094Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.43 247.124L57.3585 252.308L9.97068 225.228C1.25478 220.247 1.25476 207.68 9.97067 202.699L30.3901 191.03C39.2552 185.964 50.1386 185.965 59.003 191.032C76.5979 201.09 94.1928 211.147 111.787 221.205L102.716 226.389L56.1335 199.761C49.044 195.709 40.3401 195.707 33.2489 199.756L20.4383 207.072C15.1102 210.115 15.1091 217.797 20.4364 220.841L66.43 247.124Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.646 190.104L547.217 159.002L438.359 221.206L492.788 252.309L601.646 190.104Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.646 190.105L592.574 184.921L483.716 247.125L492.788 252.309L601.646 190.105Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.288 164.186L547.217 159.002L438.359 221.206L447.43 226.39L556.288 164.186Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.155 216.022L501.211 214.727L483.068 225.094L485.012 226.39L503.155 216.022Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.931 314.514L329.502 283.412L220.644 345.617L269.351 373.449C272.897 375.475 277.249 375.475 280.795 373.449L383.931 314.514Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.35 373.449C272.895 375.475 277.248 375.475 280.793 373.449L329.5 345.617L220.643 283.412L166.214 314.514L269.35 373.449Z",
    fill: "#434242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.859 309.331L383.931 314.515L280.795 373.45C277.249 375.476 272.897 375.476 269.351 373.45L166.215 314.515L175.287 309.331L269.351 363.082C272.897 365.108 277.249 365.108 280.795 363.082L374.859 309.331Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.501 283.412L338.572 288.596L277.933 323.247C276.16 324.26 273.984 324.26 272.211 323.247L211.571 288.596L220.643 283.412L275.072 314.514L329.501 283.412Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.576 314.28L217.984 315.576L236.127 325.943L238.719 324.647L220.576 314.28Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.094 311.923L330.15 310.627L312.007 320.994L313.951 322.29L332.094 311.923Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5151_105939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.135 47.6199C317.135 21.7198 296.139 0.723633 270.239 0.723633C244.339 0.723633 223.343 21.7198 223.343 47.6199C223.343 55.4655 225.484 65.819 229.904 71.6755L266.267 119.868C268.258 122.506 272.221 122.506 274.212 119.868L310.575 71.6755C315.44 65.2276 317.135 56.2816 317.135 47.6199Z",
    fill: "#F8BD30"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5151_105939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.598 42.748C274.148 42.748 271.844 43.7884 270.006 45.6703C268.172 43.7691 265.895 42.748 263.401 42.748C259.045 42.748 255.197 45.9075 254.044 50.4311C253.44 52.8006 253.313 56.5723 256.141 61.0822C258.667 65.1101 263.006 68.8204 269.036 72.11C269.336 72.2736 269.667 72.3553 269.998 72.3553C270.329 72.3553 270.66 72.2736 270.959 72.1103C276.992 68.8206 281.331 65.1103 283.858 61.0824C286.688 56.5725 286.562 52.8012 285.958 50.4316C284.804 45.9075 280.955 42.748 276.598 42.748ZM269.998 68.047C256.816 60.5147 257.42 53.4465 257.936 51.4235C258.624 48.724 260.922 46.7647 263.4 46.7647C265.286 46.7647 267.019 47.9118 268.28 49.9949C268.643 50.5958 269.295 50.9629 269.997 50.9632C270.7 50.9632 271.351 50.5963 271.715 49.9957C272.978 47.9121 274.712 46.7647 276.598 46.7647C279.078 46.7647 281.377 48.724 282.065 51.4235C282.581 53.4463 283.184 60.5142 269.998 68.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.336 39.3049C265.654 39.3049 269.166 35.7925 269.166 31.4751C269.166 27.1572 265.654 23.6445 261.336 23.6445C257.018 23.6445 253.505 27.1575 253.505 31.4751C253.505 35.7925 257.018 39.3049 261.336 39.3049ZM261.336 27.6612C263.439 27.6612 265.15 29.3723 265.15 31.4751C265.15 33.5777 263.439 35.2883 261.336 35.2883C259.233 35.2883 257.522 33.5777 257.522 31.4751C257.522 29.372 259.233 27.6612 261.336 27.6612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.666 39.3049C282.983 39.3049 286.496 35.7925 286.496 31.4751C286.496 27.1572 282.983 23.6445 278.666 23.6445C274.348 23.6445 270.835 27.1575 270.835 31.4751C270.835 35.7925 274.348 39.3049 278.666 39.3049ZM278.666 27.6612C280.768 27.6612 282.479 29.3723 282.479 31.4751C282.479 33.5777 280.768 35.2883 278.666 35.2883C276.562 35.2883 274.852 33.5777 274.852 31.4751C274.852 29.372 276.562 27.6612 278.666 27.6612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.248 35.5176C243.251 35.5176 240 38.7692 240 42.766C240 46.7623 243.251 50.0134 247.248 50.0134C251.244 50.0134 254.496 46.762 254.496 42.766C254.496 38.7692 251.244 35.5176 247.248 35.5176ZM247.248 45.9967C245.466 45.9967 244.017 44.5475 244.017 42.766C244.017 40.9842 245.466 39.5345 247.248 39.5345C249.029 39.5345 250.479 40.9842 250.479 42.766C250.479 44.5475 249.03 45.9967 247.248 45.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.752 35.5176C288.755 35.5176 285.504 38.7692 285.504 42.7658C285.504 46.762 288.755 50.0131 292.752 50.0131C296.749 50.0131 300 46.7618 300 42.7658C300 38.7692 296.749 35.5176 292.752 35.5176ZM292.752 45.9967C290.97 45.9967 289.521 44.5473 289.521 42.766C289.521 40.9842 290.97 39.5345 292.752 39.5345C294.534 39.5345 295.983 40.9842 295.983 42.766C295.983 44.5475 294.534 45.9967 292.752 45.9967Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5151_105939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 523,
    height: 376.339,
    fill: "white",
    transform: "matrix(-1 0 0 1 523 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5151_105939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.409,
    height: 124.409,
    fill: "white",
    transform: "matrix(-1 0 0 1 332.442 0.724609)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5151_105939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60.0001,
    fill: "white",
    transform: "translate(240 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinariasIlus);
export default __webpack_public_path__ + "static/media/veterinarias-ilus.5a5ce9dfd0473f65fa6011a0a9cb62da.svg";
export { ForwardRef as ReactComponent };